const Cv = () => {

    return(
    <div>
        <h1>Experience</h1>
        <br/>
        <p>October 2020 - now</p>
        <p>SedamIT d.o.o., Koledovčina ul. 2, Zagreb</p>
        <p>Software Developer</p>
        <p>developing and maintaining a network monitoring application based on Zabbix</p>
        <p>research & development of a next generation unified, real-time threat detection and monitoring SOC solution  - 5 year <a href="https://www.sedamit.hr/program-eu7/iri2-soc4-0" target="_blank" rel="noreferrer">EU funded project</a></p>
        <p>implementation and maintainance of distributed systems: Apache Kafka, Apache Spark, Elasticsearch, Logstash</p>
        <br/>
        <hr></hr>
        <br/>
        <p>May 2017 - September 2020</p>
        <p>IDE3 d.o.o., Vrapčanska 92, Zagreb</p>
        <p>Software Developer</p>
        <p>developing and maintaining custom web applications in various bussiness domains</p>
        <p>modernizing and improving development operations and code quality</p>
        <br/>
        <hr></hr>
        <br/>

        <p>July 2016 - August 2016</p>
        <p>Trikoder d.o.o., Miroslava Miholića 2, Zagreb</p>
        <p>Summer Internship</p>
        <p>web application development in PHP Symfony</p>
        <p>collaboration with other interns and mentors</p>
        <br/>
        <hr></hr>
        <br/>

        <p>June 2015 - September 2015</p>
        <p>Integrirani poslovni sustavi d.o.o. / ESC d.o.o., Mokrice 100, Oroslavje</p>
        <p>IT technician</p>
        <p>configuring and implementing POS systems on smaller computer networks</p>
        <p>maintaining user's computers (hardware and software troubleshooting)</p>
        <p>reporting bugs to the development team</p>
        <br/>
        <br/>

        <h1>Education</h1>
        <br/>
        <p>Zagreb University of Applied Sciences, Vrbik 8, Zagreb Croatia</p>
        <p>2018 - 2021</p>
        <p>Master of Information security and Digital forensics (M.Sc.)</p>
        <p>Thesis subject: "Real time end-point threat detection using Elasticsearch"</p>
        <br/>
        <hr></hr>
        <br/>

        <p>Algebra University college, Ilica 242, Zagreb Croatia</p>
        <p>May 2018 - September 2018</p>
        <p>Application development in Java on the Android platform</p>
        <p>Practical exam project: "Asset Management Android application"</p>
        <br/>
        <hr></hr>
        <br/>
        
        <p>Zagreb University of Applied Sciences, Vrbik 8, Zagreb Croatia</p>
        <p>2012 - 2016</p>
        <p>Bachelor of Applied Science (B.A.Sc.), Information Technology</p>
        <p>Thesis subject: "Natural Language Processing using Python"</p>
        <p>Clubs: Chess</p>
        

    </div>
    );
}

export default Cv;